
const digest = '663c7358be39dffeed45068232130eef6a71033d873319336eaff38a44a640d8';
const css = `._commandMenuItemIcon_1qab6_1 {
  margin-right: var(--spacer-1);
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"commandMenuItemIcon":"_commandMenuItemIcon_1qab6_1"};
export { css, digest };
  